export default "__VITE_ASSET__JhKqU0jD__"